import _ from "lodash";
import { defaultDisplaySetting } from "../component/helpers/preSelectedFilters";

//Get Structure according to display Setting
export const getStructureDpSetting=(structure:any,displaySetting:any)=>{
  const {showPhases,showWeeks,showChapters,showConcepts}=displaySetting;
      if(showPhases){
          if(showWeeks){
              if(showChapters && showConcepts){
                 return structure;
              }
             else if(!showChapters && showConcepts){
              structure.forEach((struct:any,phaseIndx:number)=>{
                  struct.children.forEach((ch:any,weekIndx:number)=>{
                     let weekChapterContent:any=[];
                     let newChildren:any=[];
                     ch.children.forEach((chapter:any,chapterIndx:number)=>{
                          newChildren=[...newChildren,...chapter.children];
                          weekChapterContent=[...weekChapterContent,...chapter.content];
                          // const{phaseIndex,weekIndex,subjectIndex,chapterIndex}=chapter;
                          // newTreeData.phases[phaseIndx].weeks[weekIndx].subjects[subjectIndex].chapters[chapterIndex].hideChapterLevel=false;
                     });
                    ch.chapterContent=weekChapterContent;
                    ch.children=newChildren;
                  });
              });
             }else if(showChapters && !showConcepts){
               structure.forEach((struct:any,phaseIndx:number)=>{
                  struct.children.forEach((ch:any,weekIndx:number)=>{
                     ch.children.forEach((chapter:any,chapterIndx:number)=>{
                        let conceptContent:any =[];
                        chapter.children.forEach((concept:any) => {
                            conceptContent=[...conceptContent,...concept.content];
                        });
                        chapter.conceptContent=conceptContent;
                        chapter.chapterContent=chapter.content;
                        chapter.children=[];
                     });
                  });
              });
             }
             else{
              structure.forEach((struct:any,phaseIndx:number)=>{
                struct.children.forEach((ch:any,weekIndx:number)=>{
                   let weekChapterContent:any=[];
                   let weekConceptContent:any=[];
                   ch.children.forEach((chapter:any,chapterIndx:number)=>{
                       chapter.children.forEach((concept:any) => {
                         weekConceptContent=[...weekConceptContent,...concept.content];
                       });
                        weekChapterContent=[...weekChapterContent,...chapter.content];
                   });
                  ch.chapterContent=weekChapterContent;
                  ch.conceptContent=weekConceptContent;
                  ch.children=[];
                });
              }); 
             }
          }else{
            if(showChapters && showConcepts){
              structure.forEach((phase:any,phaseIndx:number)=>{
                   let newChildren:any=[];
                   let phaseContent:any=[];
                phase.children.forEach((week:any,weekIndx:number)=>{
                        newChildren=[...newChildren,...week.children];  
                        phaseContent=[...phaseContent,..._.get(week,"content",[])];    
                });
                phase.children=newChildren;
                phase.content=phaseContent;
              });
            }
            else if(showChapters && !showConcepts){
              structure.forEach((phase:any,phaseIndx:number)=>{
                let newChildren:any=[];
                let phaseContent:any=[];
               phase.children.forEach((week:any,weekIndx:number)=>{
                 week.children.forEach((chapter:any) => {
                     let newConceptContent:any=[];
                       chapter.children.forEach((concept:any)=>{
                        newConceptContent=[...newConceptContent,...concept.content];
                       })
                       chapter.conceptContent=newConceptContent;
                      //  As we not showing concepts so to show chapter content move chapter content to chapterLevelContent
                       chapter.chapterContent=chapter.content;
                       chapter.children=[];
                    });
                     newChildren=[...newChildren,...week.children];    
                     phaseContent=[...phaseContent,..._.get(week,"content",[])];   
               });
             phase.children=newChildren;
             phase.content=phaseContent;
             });
            }
            else if(!showChapters && showConcepts){
              structure.forEach((phase:any,phaseIndx:number)=>{
                let newChildren:any=[];
                let newChapterContent:any=[];
                let phaseContent:any=[];
               phase.children.forEach((week:any,weekIndx:number)=>{
                 week.children.forEach((chapter:any) => {
                       newChapterContent=[...newChapterContent,...chapter.content];
                       newChildren=[...newChildren,...chapter.children];
                    });
                    phaseContent=[...phaseContent,..._.get(week,"content",[])];   
               });
             phase.children=newChildren;
             phase.chapterContent=newChapterContent;
             phase.content=phaseContent;
             });
            }else{
              structure.forEach((phase:any,phaseIndx:number)=>{
                let newConceptContent:any=[];
                let newChapterContent:any=[];
                let phaseContent:any=[];
               phase.children.forEach((week:any,weekIndx:number)=>{
                 week.children.forEach((chapter:any) => {
                       newChapterContent=[...newChapterContent,...chapter.content];
                       chapter.children.forEach((concept:any)=>{
                        newConceptContent=[...newConceptContent,...concept.content];
                       })
                    });
                    phaseContent=[...phaseContent,..._.get(week,"content",[])];  
               });
             phase.children=[];
             phase.chapterContent=newChapterContent;
             phase.conceptContent=newConceptContent;
             phase.isDisable=true;
             phase.content=phaseContent;
             });
            }
          }    
      }
      
  //  if(!_.isEmpty(newTreeData)){
  //    console.log({newTreeData});
  //     setTreeData({treeData:newTreeData});   
  //  }
  return structure;    
}

export const formatterConvertorForCourse = (apiData: any,phaseAlignment?:any,isPreviewScreen?:boolean) => {
  const { phases = [] } = apiData;
  let clonePhases = JSON.parse(JSON.stringify(phases));
  let structure: any = JSON.parse(JSON.stringify([...giveArrayOnPhaseLength(clonePhases.length)]));
  clonePhases.forEach((phase: any, indexOfPhase: number) => {
    let phaseIndex =-1;
    if(phaseAlignment && Object.keys(phaseAlignment).length){
     phaseIndex = phases.findIndex((ele:any)=>ele._id === phaseAlignment.id)
    }
    structure[indexOfPhase] = { ...structure[indexOfPhase], ...phase };
    delete structure[indexOfPhase]['weeks'];
    if (phase.hasOwnProperty('weeks')) {
      const { weeks = [] } = phase;
      structure[indexOfPhase] = {
        ...structure[indexOfPhase],
        children: [...weeks],
        key: `phase`,
        phaseIndex: indexOfPhase,
        isDisable:(phaseIndex >-1 && phaseIndex <= indexOfPhase)?true:false
      };
      weeks.forEach((weekPhase: any, indexOfweek: number) => {
        structure[indexOfPhase]['children'][indexOfweek] = {
          ...structure[indexOfPhase]['children'][indexOfweek],
          ...weekPhase,
        };
        if (weekPhase.hasOwnProperty('subjects')) {
          const { subjects = [] } = weekPhase;
          structure[indexOfPhase]['children'][indexOfweek] = {
            ...structure[indexOfPhase]['children'][indexOfweek],
            children: [],
            key: 'week',
            name: `Week ${weekPhase.weekNo}`,
            weekIndex: indexOfweek,
            phaseIndex: indexOfPhase,
            isDisable:(phaseIndex >-1 && phaseIndex <= indexOfPhase)?true:false
          };
          let indexOfChapterPhaseOverall = 0;
          let children: any = [];
          subjects.forEach((subjectPhase: any, indexOfSubject: number) => {
            if (subjectPhase.hasOwnProperty('chapters')) {
              const { chapters = [] } = subjectPhase;
              chapters.forEach((chapterPhase: any, indexOfChapterPhase: number) => {
                structure[indexOfPhase]['children'][indexOfweek] = {
                  ...structure[indexOfPhase]['children'][indexOfweek],
                  children: [
                    ...structure[indexOfPhase]['children'][indexOfweek]['children'],
                    { ...chapterPhase },
                  ],
                  key: 'week',
                  name: `Week ${weekPhase.weekNo}`,
                  weekIndex: indexOfweek,
                  phaseIndex: indexOfPhase,
                  isDisable:(phaseIndex >-1 && phaseIndex <= indexOfPhase)?true:false
                };
                if (chapterPhase.hasOwnProperty('concepts')) {
                  const { concepts = [] } = chapterPhase;
                  structure[indexOfPhase]['children'][indexOfweek]['children'][
                    indexOfChapterPhaseOverall
                  ] = {
                    ...structure[indexOfPhase]['children'][indexOfweek]['children'][
                      indexOfChapterPhaseOverall
                    ],
                    children: [...concepts],
                    key: 'chapter',
                    subjectIndex: indexOfSubject,
                    chapterIndex: indexOfChapterPhase,
                    weekIndex: indexOfweek,
                    phaseIndex: indexOfPhase,
                    subjectName: subjectPhase.name,
                    subjectId: subjectPhase.id,
                    chapterId: chapterPhase.id,
                    isDisable:(phaseIndex >-1 && phaseIndex <= indexOfPhase)?true:false
                  };
                  concepts.forEach((conceptPhase: any, indexOfConceptPhase: number) => {
                    structure[indexOfPhase]['children'][indexOfweek]['children'][
                      indexOfChapterPhaseOverall
                    ]['children'][indexOfConceptPhase] = {
                      ...structure[indexOfPhase]['children'][indexOfweek]['children'][
                        indexOfChapterPhaseOverall
                      ]['children'][indexOfConceptPhase],
                      ...conceptPhase,
                      key: 'concept',
                      children: [],
                      subjectIndex: indexOfSubject,
                      chapterIndex: indexOfChapterPhase,
                      conceptIndex: indexOfConceptPhase,
                      chapterContent: concepts.length - 1 === indexOfConceptPhase ? chapterPhase.content : [],
                      isBulkAdded: chapterPhase.isBulkDataAdded ? true : false,
                      weekIndex: indexOfweek,
                      phaseIndex: indexOfPhase,
                      subjectId: subjectPhase.id,
                      chapterId: chapterPhase.id,
                      hideChapterLevel: chapterPhase.hideChapterLevel,

                      subjectName: subjectPhase.name,
                    };
                  });
                }
                indexOfChapterPhaseOverall = indexOfChapterPhaseOverall + 1;
              });
            }
          });
        }
      });
    }
  });

  // console.log(structure, '::::::::::::::::::struct::::::::::::::::::');
  // structure.forEach((struct:any,i:number)=>{
  //    let newChildren:any[]=[];
  //      struct.children.forEach((ch:any)=>{
  //         newChildren=[...newChildren,...ch.children];
  //      });
  //        struct.children=newChildren;
  // });
  const {displaySettings=defaultDisplaySetting}=apiData; 
    structure=getStructureDpSetting(structure,displaySettings);
  return structure;
};

const giveArrayOnPhaseLength = (length: number) => {
  let phaseArray: any = [];
  for (let i = 0; i < length; i++) {
    phaseArray.push({});
  }
  return phaseArray;
};
